export * from './image-ocr.component';
export * from './capture-picture/capture-picture.component';
export * from './scan-barcode/capture-scan-barcode.component';
export * from './thumbnails/thumbnails.component';
export * from './ocrdata/ocrdata.component';
export * from './ocrdata/nutrition-facts/nutrition-fact.component';
export * from './ocrdata/serving-editor/serving-editor.component';